<template>
  <b-list-group>
    <b-list-group-item
      class="text-white"
      :style="`background-color: ${item.cor};display: flex; align-content: stretch`"
      v-for="item in itens"
      role="button"
      :key="item.id"
      @click.prevent="setSituacao(item)"
    >
      <span class="span-situacao">{{ item.nome }} </span>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
export default {
  data() {
    return {
      itens: [],
    };
  },
  props: {
    tarefa_id: Number,
  },
  created() {
    this.getSituacoes();
  },
  methods: {
    async getSituacoes() {
      const result = await this.$api.get("tarefa/getSituacoes");
      this.itens = result.data;
    },
    async setSituacao(item) {
      await this.$api.put("tarefa/setSituacao", {
        tarefa_id: this.tarefa_id,
        situacao_id: item.situacao_id,
        nome: item.nome,
      });
      this.$emit("updateCartao");
      this.$bvModal.hide("situacao");
    },
  },
};
</script>